import React, { useState, useEffect } from 'react';

const ImageSlider = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [nextSlide, setNextSlide] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const [slideDirection, setSlideDirection] = useState('next');

  useEffect(() => {
    let interval;
    if (isPlaying && !isTransitioning && images.length > 1) {
      interval = setInterval(() => {
        handleSlideChange('next');
      }, 3000);
    }
    return () => clearInterval(interval);
  }, [isPlaying, isTransitioning, images]);

  const handleSlideChange = (direction) => {
    if (isTransitioning || images.length <= 1) return;
    
    setIsTransitioning(true);
    setSlideDirection(direction);
    
    const nextIndex = direction === 'next' 
      ? (currentSlide + 1) % images.length
      : (currentSlide - 1 + images.length) % images.length;
    
    setNextSlide(nextIndex);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.querySelector('.slider-container').classList.add('transitioning');
      });
    });

    setTimeout(() => {
      setCurrentSlide(nextIndex);
      setIsTransitioning(false);
      document.querySelector('.slider-container').classList.remove('transitioning');
    }, 1000);
  };

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="relative w-full h-[527px] sm:h-[400px] md:h-[250px] lg:h-[527px] bg-black overflow-hidden imageSliderWrp">
      <div className={`slider-container relative w-full h-full ${isTransitioning ? 'transitioning' : ''}`}>
        {/* Current Slide */}
        <div className="absolute inset-0">
          <img
            src={images[currentSlide]}
            alt={`Slide ${currentSlide + 1}`}
            className="w-full h-full object-contain"
          />
        </div>
        
        {/* Next Slide */}
        <div className={`absolute inset-0 next-slide ${slideDirection}`}>
          <img
            src={images[nextSlide]}
            alt={`Slide ${nextSlide + 1}`}
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {images.length > 1 && (
        <div className="absolute top-0 left-10 right-10 flex justify-between items-center h-10 px-4">
          <button 
            onClick={() => setIsPlaying(!isPlaying)} 
            className="text-white font-semibold text-sm hover:text-yellow-300 transition-colors"
          >
            {isPlaying ? 'Pause ||' : 'Play ▶'}
          </button>
          
          <div className="flex gap-4">
            <button 
              onClick={() => handleSlideChange('prev')} 
              className="text-white hover:text-yellow-300 transition-colors"
              disabled={isTransitioning}
            >
              ◄
            </button>
            <button 
              onClick={() => handleSlideChange('next')} 
              className="text-white hover:text-yellow-300 transition-colors"
              disabled={isTransitioning}
            >
              ►
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .slider-container {
          transform-style: preserve-3d;
        }

        .next-slide {
          clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
          transition: clip-path 1s ease-in-out;
        }

        .slider-container.transitioning .next-slide {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }

        .next-slide.prev {
          clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);
        }

        .slider-container.transitioning .next-slide.prev {
          clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }

        .control-button {
          background: rgba(0, 0, 0, 0.5);
          color: white;
          padding: 8px 16px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
        }

        .control-button:hover {
          background: rgba(0, 0, 0, 0.7);
        }

        .control-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default ImageSlider;